import { Message } from 'element-ui'
import Vue from 'vue'
import VueRouter from 'vue-router';
import cnt from '@/api/cnt';


Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        // redirect: '/cnt',
        component: () =>
            import ('../views/home.vue')
    },
    {
        path: '/welcome',
        name: 'Home',
        component: () =>
            import ('../views/home.vue')
    },
    {
        path: '/active',
        name: 'Home',
        component: () =>
            import ('../views/home.vue')
    },
    // {
    //     path: '/active',
    //     component: () =>
    //         import ('../views/home.vue'),
    //     children:[{
    //         name: 'Home',
    //         path: '9',
    //         component: () =>
    //         import ('../views/home.vue')
    //     }]
    // },

    {
        path: '/trip',
        name: 'Cnt',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/cnt.vue')
    },
    {
        path: '/carconList',
        name: 'carconList',
        component: () =>
            import ('../views/carconList.vue')
    },
    {
        path: '/welcome-home',
        name: 'welcome',
        component: () =>
            import ('../views/welcome.vue')
    },
    {
        path: '/password',
        name: 'password',
        component: () =>
            import ('../views/password.vue')
    },
    {
        path: '/result',
        name: 'result',
        component: () =>
            import ('../views/result.vue')
    },
    {
        path: '/resultCard',
        name: 'resultCard',
        component: () =>
            import ('../views/resultCard.vue')
    },
    {
        path: '/certificate',
        name: 'certificate',
        component: () =>
            import ('../views/certificate.vue')
    },
    {
        path: '/certificateTemplate',
        name: 'certificateTemplate',
        component: () =>
            import ('../views/certificateTemplate.vue')
    },
    {
        path: '/info',
        name: 'info',
        component: () =>
            import ('../views/info.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        component: () =>
            import ('../views/detail.vue')
    },
    {
        path: '/nftpay',
        name: 'orderDetail',
        component: () =>
            import ('../views/orderDetail.vue')
    },
    {
        path: '/success',
        name: 'success',
        component: () =>
            import ('../views/success.vue')
    },
    {
        path: '/carsuccess',
        name: 'carsuccess',
        component: () =>
            import ('../views/carsuccess.vue')
    },
    {
        path: '/help',
        name: 'help',
        component: () =>
            import ('../views/help.vue')
    },
    {
        path: '/helpDetail',
        name: 'helpDetail',
        component: () =>
            import ('../views/helpDetail.vue')
    },
    {
        path: '/service',
        name: 'service',
        component: () =>
            import ('../views/service.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () =>
            import ('../views/404.vue')
    },
    {
        path: '*',
        redirect: '/404'
      }


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const config = JSON.parse(sessionStorage.getItem('configData')) || '';

    // 允许访问的白名单页面
    const whiteList = ['/', '/welcome', '/active', '/welcome-home', '/result', '/resultCard', '/certificateTemplate', '/404'];

    // 判断是否在白名单
    const isWhitePath = whiteList.some(item => to.path === item);
    console.log(1,'进入路由守卫')

    if (isWhitePath) {
        console.log(2,'进入白名单页面')
        next();
    } else {
        if (config) {
            console.log(3,'进入有config的页面')
            next();
        } else {
            console.log(4,'进入没有config的页面')
            next('/404');
        }
    }
});

export default router